import { TrainingInsightFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const useMore40hs = (insights: TrainingInsightFragment) => {
  const usage = insights.employeesWithMore40h

  const more40hs = [
    {
      value: usage?.more40hEmployees || 0,
      label: i18n.t('trainings.insights.charts.more_40hs.more'),
      originalLabel: i18n.t('trainings.insights.charts.more_40hs.more'),
      id: 1,
    },
    {
      value: usage?.less40hEmployees || 0,
      label: i18n.t('trainings.insights.charts.more_40hs.less'),
      originalLabel: i18n.t('trainings.insights.charts.more_40hs.less'),
      id: 2,
    },
  ]
  return { more40hs }
}
